import _Const from '@/Const';
/** 枚举中value转label */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function valueToLabel(value: any, optionName: string) {
  const label = _Const[optionName].find(item => item.value === value);
  return label ? label.name : '';
}
